module.exports = __webpack_public_path__ + "static/img/5.759ecd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/5.png
// module id = 1RWA
// module chunks = 0